<template>
  <!-- <div> -->
    <ul class="el-upload-list el-upload-list--picture-card">
      <li tabindex="0"
        v-for="(item, index) in fileList"
        :key="index"
        class="el-upload-list__item is-success"
        style="width:72px;height:72px;vertical-align: top;">
        <!-- <img :src="item.url"
          class="el-upload-list__item-thumbnail"> -->
          <el-image  class="el-upload-list__item-thumbnail" fit="contain"
            :src="item.url" :preview-src-list="list"></el-image>
        <!-- <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview">
            <i class="el-icon-zoom-in"
              @click="handlePictureCardPreview(item)"></i>
          </span>
        </span> -->
      </li>
    </ul>
    <!-- <el-dialog :visible.sync="previewVisible"
      width="600px"
      append-to-body>
      <img width="100%"
        :src="previewUrl">
    </el-dialog> -->
  <!-- </div> -->
</template>

<script>
export default {
  name: 'image-list',
  components: {},
  props: {
    fileList: {
      type: Array,
      required: true,
      default () {
        return []
      }
    }
  },
  // data () {
  //   return {
  //     previewVisible: false,
  //     previewUrl: ''
  //   }
  // },
  // watch: {},
  computed: {
    list ({ fileList }) {
      return fileList.map(i => i.url)
    }
  }
  // methods: {
  //   handlePictureCardPreview (item) {
  //     this.previewUrl = item.url
  //     this.previewVisible = true
  //   }
  // },
  // created () { },
  // mounted () { }
}
</script>
<style lang="stylus" scoped></style>
